<template>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Plot Rent Demand Notice</title>
    <link rel="shortcut icon" href="images/favicon.png" type="image/x-icon">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Yellowtail&display=swap" rel="stylesheet">
  </head>

  <body style="padding: 0px; margin: 0px; font-family: 'Montserrat', sans-serif; background-color: #a2a2a21c;box-sizing: border-box;">

  <button class="print-btn" onclick="window.print()"><img src="assets/printer.svg" alt="Printer Icon"></button>
  <button class="print-btn email-doc" title="Send On Email" @click="sendEmail"><img src="assets/email-icon.png" alt="Email Icon"></button>

  <page class="page" style="width: 210mm; height:297mm; display: flex; position: relative; flex-flow: column; background-color: white;">
    <!-- main content -->
    <div style="padding: 8.5mm;">

      <header style="display: flex; height: 47mm; align-items: center; position: relative; width: 100%; justify-content: space-between;">
        <div>
          <img :src="state_logo()" style="height: 36mm; margin-right: 0mm;">
        </div>
        <div style="text-align: center; margin-right: 8.5mm; margin-left: 8.5mm;">
          <h2 style="
                        margin-top: 0px;
                        font-size: 26px;
                        text-transform: uppercase;
                        color: #4ca82c;
                        font-weight: 700;
                        margin-bottom: 1.2mm;
                        padding-bottom: 0px;
                    ">
            County Government Of <br> {{county.countyName}}
          </h2>

          <h4 style="padding: 0px;
                    margin: 0px;
                    font-size: 18px;
                    font-weight: bold; text-transform: uppercase; margin-bottom: 0; color: #dc3545;">
            Plot Rent Demand Notice
          </h4>

          <h4 style="padding: 0px;
                    margin: 0px;
                    font-size: 13px;
                    font-weight: 400; font-style: italic; font-family: 'Times New Roman', Times, serif; margin-top: 2mm; margin-bottom: 4.5mm;">
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif; margin-right: 3mm;">{{getNoticeTypeLabel()}}</span>
          </h4>

          <h4 style="padding: 0px;
                    margin: 0px;
                    font-size: 14px;
                    font-weight: 400;">
            {{county.address}} <br>
            Email: {{county.email}}
          </h4>

          <h4 style="padding: 0px;
                    margin: 0px;
                    font-size: 13px;
                    font-weight: 400; font-style: italic; font-family: 'Times New Roman', Times, serif; margin-top: 2mm; line-height: 1.4;">
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif; display: block; margin-bottom: 1mm;">{{county.tagline}}</span>
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif; display: block;">#{{county.tagline2}}</span>
          </h4>
        </div>
        <div>
          <img :src="county_logo()" style="height: 36mm; margin-right: 0mm;">
        </div>
      </header>

      <div>
        <img src="./assets/red-line.png" style="width: 100%;">
      </div>

      <!-- contact information and notice reference -->
      <div style="display: flex; justify-content: space-between;">
        <!-- contact information -->
        <div style="font-size: 12px; margin-top: 1.5mm;">
          <p style="padding: 0px; margin: 0px; padding-top: 0mm; padding-bottom: 1.5mm; margin-top:0.05mm;">Printed By <strong style="text-transform:uppercase;">{{sessionNames}}</strong></p>
          <p style="padding: 0px; margin: 0px; padding-top: 0mm; padding-bottom: 1.5mm; margin-top:1.5mm;">Date Printed <strong style="text-transform:uppercase;">{{formatDate(showDate())}}</strong></p>
        </div>
        <!-- Notice Reference -->
        <div style="font-size: 12px; margin-top: 1.5mm; text-align: right;">
          <p style="padding: 0px; margin: 0px; padding-top: 0mm; padding-bottom: 1.5mm; margin-top:0.05mm;">Notice Ref: <strong style="text-transform:uppercase;">{{noticeRef}}</strong></p>
          <p style="padding: 0px; margin: 0px; padding-top: 0mm; padding-bottom: 1.5mm; margin-top:1.5mm;">Payment Deadline: <strong style="text-transform:uppercase; color: #dc3545;">{{formattedDeadline}}</strong></p>
        </div>
      </div>

      <!-- the plot information table -->
      <table style="margin-top:6.3mm; border-spacing: initial; width: 100%;">
        <thead class="" style="text-transform: uppercase;
                font-weight: 700;
                font-size: 12px;
                background: #9e9e9e2e;
                padding: 2.5mm;">
        <tr>
          <td colspan="3" style="padding: 2.5mm;">Notice Date: {{formatDate(plot.dateCreated)}}</td>
        </tr>
        </thead>
        <tbody style="font-size: 12px; text-transform: uppercase; text-wrap: nowrap;">
        <tr>
          <td>
            <span>Plot No.: </span>
            <strong style="color: #0045a1;">{{plot.plotNumber}}</strong>
          </td>
          <td>
            <span>Zone/Market: </span>
            <strong>{{plot.zone}}</strong>
          </td>
          <td>
            <span>Plot Size: </span>
            <strong>{{plot.plotSize || 'N/A'}}</strong>
          </td>
        </tr>

        <tr>
          <td>
            <span>Sub County: </span>
            <strong>{{plot.subCountyName}}</strong>
          </td>
          <td>
            <span>Ward: </span>
            <strong>{{plot.wardName || 'N/A'}}</strong>
          </td>
          <td>
            <span>Status: </span>
            <strong :style="getStatusColor(plot.status)">{{plot.status}}</strong>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <span>Plot Owner: </span>
            <strong>{{plot.ownerNames}}</strong>
          </td>
          <td>
            <span>ID/Passport: </span>
            <strong>{{plot.ownerID || 'N/A'}}</strong>
          </td>
        </tr>

        <tr>
          <td>
            <span>Phone: </span>
            <strong>{{plot.ownerPhoneNo || 'N/A'}}</strong>
          </td>
          <td colspan="2">
            <span>Email: </span>
            <strong style="text-transform: lowercase;">{{plot.ownerEmail || 'N/A'}}</strong>
          </td>
        </tr>

        <tr>
          <td colspan="3">
            <span>Physical Address: </span>
            <strong>{{plot.plotAddress || 'Not Provided'}}</strong>
          </td>
        </tr>
        </tbody>
      </table>

      <div>
        <img src="./assets/red-line.png" style="width: 100%; margin-bottom: 0mm;">
      </div>

      <!-- billing details and summary -->
      <div style="display: flex; position: relative; margin-top: 3.3mm;">

        <!-- Stamp positioned absolutely -->
        <div style="position: absolute; left: -5mm; top: 10mm; z-index: 1;">
          <img src="./assets/demand-notice-stamp.png" style="height: 30mm; transform: rotate(45deg); opacity: 0.6;">
        </div>

        <!-- Table with proper margin to avoid stamp overlap -->
        <div style="width: 100%; margin-left: 40mm;">
          <table style="border-spacing: 0; text-transform: capitalize; font-size: 12px; width: 100%;">
            <thead style="text-transform: uppercase;
                            font-weight: 700;
                            font-size: 12px;
                            background: #9e9e9e2e;
                            padding: 2.5mm;">
            <tr>
              <td colspan="2" style="padding: 2.5mm; text-align: center; border: 1px solid #d9d9d9;">Details Of Charges</td>
            </tr>
            </thead>
            <tbody>
            <!-- Annual Rent Row -->
            <tr style="background: #e8f5e8;">
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9; width: 60%; font-weight: bold;">Annual Plot Rent</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; width: 40%; color: #28a745;">KES {{numberFormat(parseFloat(plot.annualRent) || 0)}}</td>
            </tr>

            <!-- Arrears Brought Forward Row -->
            <tr style="background: #fff3cd;">
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9;">Arrears Brought Forward</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; color: #856404;">KES {{numberFormat(parseFloat(plot.arrearsForward) || 0)}}</td>
            </tr>

            <!-- Total Billed Row -->
            <tr style="background: #e3f2fd;">
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9;">Total Amount Billed</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; color: #1565c0;">KES {{numberFormat(parseFloat(plot.totalBilled) || 0)}}</td>
            </tr>

            <!-- Accumulated Penalty Row -->
            <tr style="background: #f8d7da;">
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9;">Accumulated Penalty (25%)</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; color: #721c24;">KES {{numberFormat(parseFloat(plot.accumulatedPenalty) || 0)}}</td>
            </tr>

            <!-- Total Payments Row -->
            <tr style="background: #d1ecf1;">
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9;">Total Payments Made</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; color: #0c5460;">KES {{numberFormat(parseFloat(plot.totalPayments) || 0)}}</td>
            </tr>

            <!-- Total Amount Due Row -->
            <tr style="background: #343a40; color: white;">
              <td style="padding: 2.5mm; font-weight: bold; border: 1px solid #d9d9d9; color: white; font-size: 14px;">TOTAL AMOUNT DUE:</td>
              <td style="text-align: right; padding: 2.5mm; color: #ffeb3b; font-weight: bold; font-size: 18px; border: 1px solid #d9d9d9;">KES {{numberFormat(getCurrentBalance())}}</td>
            </tr>
            </tbody>
          </table>

          <!-- Payment Priority Information -->
          <div style="margin-top: 5mm; padding: 3mm; background: #e3f2fd; border: 1px solid #2196f3; border-radius: 3px;">
            <h6 style="margin: 0 0 2mm 0; font-size: 11px; color: #1565c0; font-weight: bold;">PAYMENT ALLOCATION PRIORITY:</h6>
            <ol style="margin: 0; padding-left: 4mm; font-size: 10px; color: #0d47a1;">
              <li style="margin-bottom: 1mm;"><strong>Oldest Arrears First:</strong> Previous years' outstanding balances</li>
              <li style="margin-bottom: 1mm;"><strong>Current Year Rent:</strong> KES {{numberFormat(parseFloat(plot.annualRent) || 0)}}</li>
              <li style="margin-bottom: 0;"><strong>Penalties:</strong> KES {{numberFormat(parseFloat(plot.accumulatedPenalty) || 0)}}</li>
            </ol>
          </div>

          <!-- Warning Box for Legal Action -->
          <div v-if="noticeType === 'legal_action'" style="margin-top: 5mm; padding: 4mm; background: #f8d7da; border: 2px solid #dc3545; border-radius: 3px;">
            <h6 style="margin: 0 0 2mm 0; font-size: 12px; color: #721c24; font-weight: bold;">⚠️ LEGAL ACTION WARNING</h6>
            <p style="margin: 0; font-size: 10px; color: #721c24; line-height: 1.4;">
              Failure to settle the outstanding amount by <strong>31st March {{getMarchYear()}}</strong> will result in:
            </p>
            <ul style="margin: 2mm 0 0 0; padding-left: 4mm; font-size: 10px; color: #721c24;">
              <li>Legal proceedings being initiated against you</li>
              <li>Additional legal costs being added to your balance</li>
              <li>Potential eviction from the plot</li>
            </ul>
          </div>

          <!-- Final Notice Warning -->
          <div v-else-if="noticeType === 'final_notice'" style="margin-top: 5mm; padding: 4mm; background: #fff3cd; border: 2px solid #ffc107; border-radius: 3px;">
            <h6 style="margin: 0 0 2mm 0; font-size: 12px; color: #856404; font-weight: bold;">⚠️ FINAL NOTICE</h6>
            <p style="margin: 0; font-size: 10px; color: #856404; line-height: 1.4;">
              This is your <strong>FINAL NOTICE</strong> before escalation to legal action. Please settle your balance immediately to avoid further consequences.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- the footer starts here -->
    <div style="padding: 8.5mm;width: 100%;background-color: #9e9e9e2e;flex-grow: 1;margin-top: 0mm;display: flex;flex-flow: column;align-items: baseline;justify-content: space-between;">
      <div style="display: flex;justify-content: space-between;width: 100%;">

        <div style="font-size: 12px;padding-top:3.3mm;">
          <h2 style="
                        margin-top: 0px;
                        font-size: 18px;
                        text-transform: uppercase;
                        color: #0045a1;
                        font-weight: 700;
                        margin-bottom: 3.3mm;
                        padding-bottom: 0px;
                        text-transform: uppercase;
                    ">
            Please note that the outstanding amount is
          </h2>
          <ol class="">
            <li style="margin-bottom: 2.5mm;">Payable at the county cash office or by other electronic means clearly outlined by the county</li>
            <li style="margin-bottom: 2.5mm;">The total amount will continue to accrue a late payment penalty at 25% per annum.</li>
            <li style="margin-bottom: 2.5mm;">Payment allocation follows priority: Oldest Arrears → Current Rent → Penalties</li>
            <li style="margin-bottom: 2.5mm;">Legal proceedings may be initiated for non-payment by <strong>31st March {{getMarchYear()}}</strong>.</li>
          </ol>

          <p><strong>Please contact the Revenue Department at county offices for any queries.</strong></p>
        </div>

        <!-- QR code for payment -->
        <div style="padding-top:3.3mm;padding-left: 17.3mm; margin-bottom: 12mm;">
          <div style="display: flex; margin-bottom: 4mm; justify-content: flex-end; align-items: center;">
            <span style="font-family: 'Yellowtail', cursive; color: #4ca82c; line-height: 0.9; font-size: 24px; text-align: right; transform: rotate(37deg);">Scan to Pay  <br>Instantly!</span>
          </div>

          <div style="position: relative; display: flex;">
            <img :src="generateQRCode()" style="height: 22mm; margin: 1.25mm;">
            <img src="assets/camera-frame.svg" style="
                        position: absolute;
                        left: 0;
                        height: 24mm;
                    ">
            <img src="assets/curved-arrow.svg" style="
                        height: 11mm;
                        margin-left: 0mm;
                        margin-top: 12px;
                    ">
          </div>
        </div>
      </div>

      <footer style="position: relative; width: 100%;">
        <div style="position: absolute; bottom: 0mm;">
          <div style="display: flex; flex-flow: column;">
            <span style="font-family: 'Yellowtail', cursive; color: #0045a1; line-height: 0.9; font-size: 20px; text-align: right;">Thank You!</span>
            <img src="assets/blue-line.png" style="width: 100%;">
          </div>

          <!-- Legal Disclaimer -->


          <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 2mm;">
            <p style="padding-bottom: 10px;margin-bottom:0px;font-size: 12px;margin-top: 0mm;">Prepared By <strong>{{plot.createdBy || sessionNames}}</strong></p>
            <p style="padding-bottom:10px; margin-bottom:0px;font-size: 12px;margin-top: 0mm; text-transform: uppercase;"><strong>Plot ID: {{plot.id}}</strong></p>
            <div style="position: absolut; display: flex; align-items: center; justify-content: center; font-size: 12px; margin-left: 8.5mm;">
              <p style="font-weight: bold;">Powered By</p>
              <img :src="county_logo()" style="height: 10mm; padding-left: 2.5mm;">
            </div>
          </div>
        </div>
      </footer>
    </div>
  </page>
  </body>
</template>

<script>
/* eslint-disable */

import {execute, plotRent, state_logo, county_logo} from "@/api";
import dayjs from 'dayjs';

export default {
  name: "PlotRentDemandNotice",
  data() {
    return {
      sessionNames: "",
      noticeRef: "",
      noticeType: "reminder",
      deadline: "",
      formattedDeadline: "",
      date: null,
      county: {
        countyName: null,
        address: null,
        email: null,
        tagline: null,
        tagline2: null
      },
      plot: {
        id: null,
        plotNumber: null,
        zone: null,
        subCountyName: null,
        subCountyID: null,
        wardName: null,
        wardID: null,
        plotSize: null,
        plotAddress: null,
        ownerNames: null,
        ownerID: null,
        ownerPhoneNo: null,
        ownerEmail: null,
        annualRent: 0,
        arrearsForward: 0,
        totalBilled: 0,
        accumulatedPenalty: 0,
        totalPayments: 0,
        currentBalance: 0,
        status: null,
        createdBy: null,
        dateCreated: null
      }
    };
  },
  mounted() {
    this.sessionNames = sessionStorage.getItem("sessionNames") || "System User";

    // Get parameters from localStorage
    try {
      const params = JSON.parse(localStorage['demandNoticeParams']);
      if (params.plotId) {
        this.noticeType = params.noticeType || 'reminder';
        this.deadline = params.deadline || '';
        this.noticeRef = params.noticeRef || this.generateNoticeRef();
        this.getPlotForDemandNotice(params.plotId);
      } else {
        alert("No plot ID provided");
      }
    } catch (error) {
      // Check URL params as fallback
      const hash = window.location.hash;
      const plotIdFromURL = hash.split('/')[3];

      if (plotIdFromURL) {
        this.noticeRef = this.generateNoticeRef();
        this.getPlotForDemandNotice(plotIdFromURL);
      } else {
        alert("No plot information found");
      }
    }

    // Set formatted deadline
    this.setFormattedDeadline();

    this.menuAccess();
  },
  methods: {
    state_logo() {
      return state_logo;
    },
    county_logo() {
      return county_logo;
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Plot Rent Demand Notice");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, plotRent)
          .then(() => {})
          .catch(() => {});
    },

    generateNoticeRef() {
      const timestamp = Date.now().toString().slice(-10);
      const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
      return `DN${timestamp}${random}`;
    },

    numberFormat(num) {
      if (num === null || num === undefined || isNaN(num)) {
        return '0';
      }
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(parseFloat(num));
    },

    formatDate(dateString) {
      if (!dateString) return dayjs().format('DD MMM YYYY [AT] hh:mm A');
      const date = dayjs(dateString);
      return date.format('DD MMM YYYY [AT] hh:mm A');
    },

    showDate() {
      return new Date();
    },

    getMarchYear() {
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = new Date().getFullYear();
      return currentMonth > 3 ? currentYear + 1 : currentYear;
    },

    setFormattedDeadline() {
      // ALL notice types use 31st March deadline
      const marchYear = this.getMarchYear();
      this.formattedDeadline = `31st March ${marchYear}`;
      this.deadline = `${marchYear}-03-31`;
    },

    getNoticeTypeLabel() {
      const labels = {
        'reminder': 'Friendly Reminder',
        'first_notice': 'First Demand Notice',
        'final_notice': 'Final Demand Notice',
        'legal_action': 'Legal Action Warning'
      };
      return labels[this.noticeType] || 'Demand Notice';
    },

    getStatusColor(status) {
      const colors = {
        'Active': 'color: #28a745;',
        'Suspended': 'color: #dc3545;',
        'Vacant': 'color: #6c757d;',
        'Transferred': 'color: #17a2b8;'
      };
      return colors[status] || 'color: #333;';
    },

    getCurrentBalance() {
      if (this.plot.currentBalance && parseFloat(this.plot.currentBalance) > 0) {
        return parseFloat(this.plot.currentBalance);
      }

      // Calculate if currentBalance is not available
      const arrears = parseFloat(this.plot.arrearsForward) || 0;
      const billed = parseFloat(this.plot.totalBilled) || 0;
      const penalty = parseFloat(this.plot.accumulatedPenalty) || 0;
      const payments = parseFloat(this.plot.totalPayments) || 0;

      return arrears + billed + penalty - payments;
    },

    generateQRCode() {
      const amount = this.getCurrentBalance();
      const plotRef = this.plot.plotNumber || this.plot.id;
      const zone = this.plot.zone || '';

      // Generate QR code for M-Pesa or bank payment
      const qrData = `Plot: ${plotRef} | Zone: ${zone} | Owner: ${this.plot.ownerNames} | Amount: KES ${this.numberFormat(amount)}`;
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(qrData)}`;
    },

    getPlotForDemandNotice(plotId) {
      const data = new FormData();
      data.append("function", "getPlotForDemandNotice");
      data.append("plotId", plotId);

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              this.plot = res.data.data.plot;
              this.county = res.data.data.county || this.county;
              console.log('Plot loaded:', this.plot);
            } else {
              alert("Error loading plot: " + res.data.message);
            }
          })
          .catch((e) => {
            console.error('Error fetching plot:', e);
            alert("Error loading plot data: " + e.message);
          });
    },

    sendEmail() {
      // Trigger email sending
      alert("Email functionality - implement as needed");
    }
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
}

.print-btn {
  display: flex;
  z-index: 1000000000;
  position: fixed;
  background: #4aaa23;
  color: white;
  top: 30px;
  right: 30px;
  border-radius: 50%;
  padding: 1rem;
  margin: 0px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 0px 20px 4px rgb(136 136 136 / 65%);
  cursor: pointer;
  transition: 0.4s;
}

.email-doc {
  top: 130px;
  background: #0063c0;
}

.print-btn img {
  height: 35px;
}

@media print {
  .print-btn {
    display: none;
  }
  body {
    margin: 0px !important;
    padding: 0px !important;
    background-color: white;
  }
  @page {
    size: A4 portrait;
    margin: 0px;
  }
}

td {
  padding: 15px;
  border: 1px solid #00000014;
}
</style>